import { render, staticRenderFns } from "./ineedResult.vue?vue&type=template&id=05f633f8&scoped=true&"
import script from "./ineedResult.vue?vue&type=script&lang=js&"
export * from "./ineedResult.vue?vue&type=script&lang=js&"
import style0 from "./ineedResult.vue?vue&type=style&index=0&id=05f633f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f633f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
